import Vue from 'vue'
import Router from 'vue-router'
import LOGIN from '@/components/LOGINREGISTER/login'
import REGISTER from '@/components/LOGINREGISTER/register'
import MAIN from '@/components/MAIN/main'
import MAKEMODELSTEPONE from '@/components/MAKEMODEL/makemodelstepone'
import MAKEMODELSTEPTWO from '@/components/MAKEMODEL/makemodelsteptwo'
import MAKEMODELSTEPTHREE from '@/components/MAKEMODEL/makemodelstepthree'
import SEEMODEL from '@/components/SEEMODEL/seemodel'
import SEEMODELDET from '@/components/SEEMODEL/seemodeldet'
import RESMODELONE from '@/components/SEEMODEL/resmodelone'
import RESMODELTWO from '@/components/SEEMODEL/resmodeltwo'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: LOGIN
    },
    {
      path: '/register',
      name: 'register',
      component: REGISTER
    },
    {
      path: '/main',
      name: 'main',
      component: MAIN
    },
    {
      path: '/makemodelstepone',
      name: 'makemodelstepone',
      component: MAKEMODELSTEPONE
    },
    {
      path: '/makemodelsteptwo',
      name: 'makemodelsteptwo',
      component: MAKEMODELSTEPTWO
    },
    {
      path: '/makemodelstepthree',
      name: 'makemodelstepthree',
      component: MAKEMODELSTEPTHREE
    },
    {
      path: '/seemodel',
      name: 'seemodel',
      component: SEEMODEL
    },
    {
      path: '/seemodeldet',
      name: 'seemodeldet',
      component: SEEMODELDET
    },
    {
      path: '/resmodelone',
      name: 'resmodelone',
      component: RESMODELONE
    },
    {
      path: '/resmodeltwo',
      name: 'resmodeltwo',
      component: RESMODELTWO
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js